import { FormEvent, ReactNode } from 'react';

interface AuthFormProps {
  onSubmit: (e: FormEvent) => void;
  children: ReactNode;
  title: string;
  description?: string;
}

export function AuthForm({
  onSubmit,
  children,
  title,
  description,
}: AuthFormProps) {
  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <h2 className="text-2xl font-semibold">{title}</h2>
        {description && <p className="text-sm text-gray-600">{description}</p>}
      </div>
      <div className="grid gap-6">
        <form onSubmit={onSubmit} className="grid gap-2">
          {children}
        </form>
      </div>
    </div>
  );
}
